import request from '@/utils/request';
// import store from '@/store';
// import router from '@/router';

/**
 * 获取角色列表（带标签）
 */
export function getRoles(params) {
  return request({
    url: '/roles',
    method: 'get',
    params
  });
}

/**
 * 搜索角色
 */
export function searchRoles(params) {
  return request({
    url: '/roles/search',
    method: 'get',
    params
  });
}

/**
 * 获取角色详情
 */
export function getRoleDetail(id) {
  return request({
    url: `/roles/${id}`,
    method: 'get'
  });
}

/**
 * 创建角色
 */
export function createRole(data) {
  return request({
    url: '/roles',
    method: 'post',
    data
  });
}

/**
 * 更新角色
 */
 export function updateRole(id, data) {
  return request({
    url: `/roles/${id}`,
    method: 'patch',
    data
  });
}

/**
 * 删除角色
 */
export function deleteRole(id) {
  return request({
    url: `/roles/${id}`,
    method: 'delete'
  });
}

/**
 * 上传角色图片
 */
export function uploadRoleImage(data) {
  return request({
    url: '/roles/upload',
    method: 'post',
    data
  });
}